import SectionVisible from 'appContainer/SectionVisible';
import { useClaimHook } from 'hooks/claim.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { BoxOverflow } from 'styles';
import Stack from 'styles/stack/Stack';
import { SECTIONS } from 'types/SectionsVisibility';
import { ClaimAttachmentsDetails } from './ClaimAttachmentsDetails.component';
import ClaimButtonList from './ClaimButtonList.component';
import ClaimMemberDetails from './ClaimMemberDetails.component';
import ClaimPaymentDetails from './ClaimPaymentDetails.component';
import ClaimComments from './components/ClaimComments/ClaimComments';
import ClaimCommentsButton from './components/ClaimComments/ClaimCommentsButton';
import ClaimHistoryDrawer from './components/ClaimHistory/ClaimHistoryDrawer.component';

const ClaimDetails = () => {
	const { claimData: claim } = useSelector((store: RootState) => store.claim);
	const {
		showClaimCommentsButton,
		showClaimCommentsForm,
		showClaimCommentsView,
	} = useClaimHook();

	return (
		<>
			{claim.claimUUID && (
				<BoxOverflow
					variant="y"
					sx={{
						display: 'flex',
						flexDirection: 'column',
						height: 'calc(100% - 10px)',
						justifyContent: 'space-between',
						gap: { lg: 7.5, sm: 3.75 },
						pr: '10px',
					}}
				>
					<Stack
						sx={{
							gap: { lg: 7.5, sm: 3.75 },
							width: '100%',
						}}
					>
						<BoxOverflow
							variant="x"
							sx={{
								width: '100%',
								pt: { lg: '50px', sm: '6px' },
							}}
						>
							<Stack flexDirection={'row'} justifyContent={'flex-end'}>
								<SectionVisible
									sectionName={SECTIONS.CLAIM_COMMENTS}
									carrier={{ customLayout: claim.customLayout }}
								>
									{showClaimCommentsButton && <ClaimCommentsButton />}
								</SectionVisible>
								<ClaimHistoryDrawer />
							</Stack>
							<ClaimMemberDetails />
							<SectionVisible
								sectionName={SECTIONS.CLAIM_COMMENTS}
								carrier={{ customLayout: claim.customLayout }}
							>
								{(showClaimCommentsView || showClaimCommentsForm) && <ClaimComments />}
							</SectionVisible>
						</BoxOverflow>

						<BoxOverflow
							variant="x"
							sx={{
								width: '100%',
							}}
						>
							<ClaimPaymentDetails />
						</BoxOverflow>
						<Stack flexDirection={'row'} justifyContent={'space-between'}>
							<ClaimAttachmentsDetails />
							<ClaimButtonList />
						</Stack>
					</Stack>
				</BoxOverflow>
			)}
		</>
	);
};

export default ClaimDetails;
